export default "__VITE_PUBLIC_ASSET__64ce5b02__"